import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from '../../features/dfte-grid-view/config/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompareserviceService {
  fromTable: boolean = false;
  nodeBaseUrl = DconConfigAPI.NODE_URL;
  options: any;
  instanceName: string;
  sourceInstance: any;
  batchStatus: any;
  targetInstance: any;
  configType: string = 'load';
  tabval = new BehaviorSubject('select');
  batchKey: string = null;
  authorizationData: any;
  projId: string;
  selectInstanceListTarget: any;
  instanceList: any;
  configObj: any;
  tracksFromTable: any;
  batchKeyDetails: any;
  requestedBy: string;
  selectDateValue: any;
  endDateValue: any;
  Base_UI_BOT = DconConfigAPI.UI_PATH;
  configFileList: any;
  token: any;
  authToken: string;
  compareTypeValue: string = null;
  Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
  localStorageToken = localStorage.getItem('authToken');
  instanceData: { sourceInstance: any; targetInstance: any };
  constructor(private https: HttpClient, private dataSrv: DataService) {
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.requestedBy = this.dataSrv.loggedUserId;
    this.projId = this.dataSrv.projectID;
    console.log('val', this.projId);
    this.dataSrv.token.subscribe((val) => {
      this.token = val;
      this.authToken = 'Bearer ' + this.token;
    });
  }

  getisTrainStopUrl() {
    const isTrainStopUrl = this.dataSrv.getisTrainStopUrl();
    return isTrainStopUrl;
  }
  getfileSharePath() {
    return this.dataSrv.windowFileSharePath;
  }

  onCreateAndCompareUpdate(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.UPDATE_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  getCompareBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIGBOOK_COMPARE_STATUS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getInstanceDetails(type: string): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Source_Type: type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getConfigDetails(type: string): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_CONFIG_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
      Extract_Application: DconConfigAPI.API_VARIABLES.CLOUD,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  onConfigSubmit(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getBatchKeyDetailsForCompare(batchKey): Observable<any> {
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
      Extract_Application: DconConfigAPI.API_VARIABLES.CLOUD, //'CLOUD',
      Batch_Key: batchKey,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getCreateDetails(): Observable<any> {
    // const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_RELEASES_FILTER + DconConfigAPI.UIPATH_COMPARE_PROCESS_NAME + "'";
    // const headers = new HttpHeaders({
    //   'Authorization': this.authToken,
    // });
    // const options = { headers: headers };
    // return this.https.get(url, options);
    const payload = {
      token: this.authToken,
      assetName: DconConfigAPI.UIPATH_COMPARE_PROCESS_NAME,
    };
    return this.https.post(
      DconConfigAPI.NODE_URL + '/uipath/uipath-releases',
      payload
    );
  }

  //DONE
  onCreate(body): Observable<any> {
    // const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_JOBS_STARTJOBS;
    // const headers = new HttpHeaders({
    //   'Authorization': this.authToken,
    // });
    // const options = { headers: headers };
    // return this.https.post(url, body, options);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers: headers };

    const payload = {
      startInfo: body.startInfo,
      token: this.authToken,
      orgId: DconConfigAPI.OrganizationUnitId,
    };
    return this.https.post(
      DconConfigAPI.NODE_URL + '/uipath/uipath-server-config-start-jobs',
      payload,
      options
    );
  }

  async uploadFileFromSFTP(formData) {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_WORKBOOK;
    const req = new HttpRequest('POST', url, formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  async uploadFileFromWorkbook(formData) {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_COMPARE;

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.localStorageToken}`,
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      });

      formData.append('isBasicAuth', 'true');

      const req = new HttpRequest('POST', url, formData, { headers });
      return await this.https.request(req);
    }

    const req = new HttpRequest('POST', url, formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  async onSubmit(batchKey) {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOK;
    const obj = {
      batchKey: batchKey,
      RequestType: 'generateWorkbook',
      RequestedBy: this.requestedBy,
    };

    const req = new HttpRequest('POST', url, obj, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  async onSubmitForCSVWorkbook(batchKey) {
    const url =
      this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CREATE_WORKBOOKEXTRACT;
    const obj = {
      batchKey: batchKey,
      RequestType: 'generateExtract',
      CompareType: 'file',
    };

    const req = new HttpRequest('POST', url, obj, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  // async onSubmitForCompare(batchKey) {
  //   const url =
  //     this.nodeBaseUrl + DconConfigAPI.URL_PROPS.COMPARE_FILE_TO_INSTANCE;
  //   const obj = {
  //     batchKey: batchKey,
  //     RequestType: 'generateExtract',
  //     CompareType: 'File',
  //     RequestedBy: this.requestedBy,
  //   };

  //   const req = new HttpRequest('POST', url, obj, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       ignoreInInterceptor: 'true',
  //     }),
  //   });
  //   return await this.https.request(req);
  // }
  async onSubmitForCompare(batchKey) {
    const url =
      this.nodeBaseUrl + DconConfigAPI.URL_PROPS.COMPARE_FILE_TO_INSTANCE;

    const obj = {
      batchKey: batchKey,
      RequestType: 'generateExtract',
      CompareType: 'File',
      RequestedBy: this.requestedBy,
    };

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.localStorageToken}`,
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      });

      obj['isBasicAuth'] = true;

      const req = new HttpRequest('POST', url, obj, { headers });
      return await this.https.request(req);
    }

    const req = new HttpRequest('POST', url, obj, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        ignoreInInterceptor: 'true',
      }),
    });
    return await this.https.request(req);
  }

  downloadFiles(payloadObj): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.DOWNLOAD_COMPARE;

    if (environment.isBasicAuth) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.localStorageToken}`,
      });

      payloadObj['isBasicAuth'] = true;

      return this.https.post(url, payloadObj, {
        headers,
        responseType: 'arraybuffer',
      });
    }

    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  }

  getSelectedBatchTasks(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url =
      this.Base_Url +
      DconConfigAPI.URL_PROPS.GET_BATCHKEY_DATA +
      DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      Authorization: this.authorizationData,
      Project_Name: this.projId,
      Requested_By: this.dataSrv.loggedUserId,
      Request_Type: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
      Source_Type: DconConfigAPI.API_VARIABLES.CLOUD,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }
}
